<ng-container
    *ngrxLet="{
        aircraftEntity: aircraftEntity$,
        isMainAircraft: isMainAircraft$,
        isInVerificationMode: isInVerificationMode$,
        violationClass: violationClass$,
        name: name$,
        emergency: emergency$,
        isHeightVisible: isHeightVisible$,
        isInfoVisible: isInfoVisible$,
        phase: phase$,
        isSelected: isSelected$,
        isTrackerSelectionEnabled: isTrackerSelectionEnabled$,
    } as vm"
>
    <ng-container *ngIf="vm.aircraftEntity">
        <div
            class="aircraft-pin {{ vm.phase | invoke : getPhaseStyleClass }}"
            [class.user-aircraft]="vm.isMainAircraft"
            [class.farada]="vm.aircraftEntity.isFaradaSource"
            [class.active]="vm.isInfoVisible"
            [class.verification]="vm.isInVerificationMode"
            [class.selected]="vm.isSelected"
            [class.emergency]="vm.emergency"
            [class.receiver-pin]="vm.aircraftEntity.aircraftType === AircraftType.Receiver"
            [ngClass]="vm.violationClass"
        >
            <div class="aircraft-icon" (click)="toggleInfoVisibility()">
                <div class="no-signal" *ngIf="vm.aircraftEntity?.isConnectionLost">
                    <dtm-ui-icon name="pin-off" />
                </div>
                <div
                    class="drone-icon-underlay"
                    [class.no-track]="!vm.aircraftEntity.position.track && vm.aircraftEntity.position.track !== 0"
                    [class.plane]="!vm.isMainAircraft && vm.aircraftEntity.aircraftType === AircraftType.Airplane"
                    [class.receiver]="vm.aircraftEntity.aircraftType === AircraftType.Receiver"
                    [ngStyle]="vm.aircraftEntity.position.track | invoke : getAircraftRotationStyles"
                ></div>

                <dtm-ui-icon
                    name="drone"
                    class="aircraft"
                    *ngIf="vm.isMainAircraft || vm.aircraftEntity.aircraftType === AircraftType.Uav"
                />
                <dtm-ui-icon
                    name="plane"
                    class="aircraft plane"
                    [ngStyle]="vm.aircraftEntity.position.track | invoke : getAircraftRotationStyles"
                    *ngIf="!vm.isMainAircraft && vm.aircraftEntity.aircraftType === AircraftType.Airplane"
                />
                <div class="receiver" *ngIf="vm.aircraftEntity.aircraftType === AircraftType.Receiver">
                    <dtm-ui-icon name="map-pin-fill" />
                    <dtm-ui-icon name="map-pin" />
                </div>
                <ng-container [ngSwitch]="vm.emergency">
                    <dtm-ui-icon class="emergency-icon aircraft" name="tools" *ngSwitchCase="EmergencyType.TechnicalIssue" />
                    <dtm-ui-icon class="emergency-icon aircraft" name="wifi-off" *ngSwitchCase="EmergencyType.LostControl" />
                    <dtm-ui-icon class="emergency-icon aircraft" name="hems-emr" *ngSwitchCase="EmergencyType.EmergencyLanding" />
                </ng-container>
            </div>
            <ng-container
                [ngTemplateOutlet]="entityInfoTemplate"
                [ngTemplateOutletContext]="{ $implicit: vm.aircraftEntity, name: vm.isMainAircraft ? vm.name : null }"
            />
        </div>
        <ng-template #entityInfoTemplate>
            <div class="drone-info" [class.receiver-info]="vm.aircraftEntity.aircraftType === AircraftType.Receiver" *ngIf="vm.isInfoVisible">
                <dtm-ui-triangle-pointer-svg class="pointer" />
                <div class="content">
                    <ng-container *ngIf="vm.name ?? vm.aircraftEntity.name as name">
                        <button
                            type="button"
                            class="button-secondary"
                            *ngIf="vm.isTrackerSelectionEnabled && vm.isMainAircraft"
                            (click)="select()"
                        >
                            {{ name }}
                        </button>
                        <span class="name" *ngIf="!vm.isTrackerSelectionEnabled || !vm.isMainAircraft" [title]="name">
                            {{ name }}
                        </span>
                    </ng-container>
                    <button type="button" class="button-tertiary" (click)="toggleHeightVisibility()">
                        {{ "dtmMapCesium.flightPin.toggleAglHeightVisibilityLabel" | transloco : { isVisible: vm.isHeightVisible } }}
                    </button>
                </div>
                <div class="flight-info">
                    <span class="label">{{ "dtmMapCesium.flightPin.heightLabel" | transloco }}:</span>
                    <div class="value">
                        <span>
                            <ng-container *ngTemplateOutlet="valueTemplate; context: { $implicit: vm.aircraftEntity.position.altitude }" />
                            {{ "dtmMapCesium.flightPin.amslLabel" | transloco }}
                        </span>
                        <span *ngIf="vm.isHeightVisible">
                            <br />
                            <ng-container *ngTemplateOutlet="valueTemplate; context: { $implicit: vm.aircraftEntity.position.height }" />
                            {{ "dtmMapCesium.flightPin.aglLabel" | transloco }}
                        </span>
                    </div>

                    <ng-container *ngIf="vm.aircraftEntity.position.accuracy | invoke : getAccuracy as accuracy">
                        <span class="label"><dtm-ui-icon name="shape-cylinder" />:</span>
                        <p class="value">
                            {{ "dtmMapCesium.flightPin.accuracyInMeters" | transloco : { value: accuracy } }}
                        </p>
                    </ng-container>
                    <div class="details-button">
                        <button type="button" class="button-icon" (click)="openDetails()">
                            <dtm-ui-icon name="arrow-go" />
                        </button>
                    </div>
                </div>
            </div>
        </ng-template>
    </ng-container>
</ng-container>
<ng-template #valueTemplate let-value>
    {{ value ? ("dtmMapCesium.flightPin.valueInMeters" | transloco : { value }) : ". . . . . . . . " }}
</ng-template>
